import {
  actions,
  getFRlowReaderAsync,
  getFlowsDatatableAsync,
  createFlowAsync,
  getFlowDetailsByIdAsync,
  editFlowAsync,
  setFlowContentEntityTypeNavigationsAsync,
  cloneFlowAsync,
  createFlowV2Async,
  editFlowV2Async,
  getFlowDetailsByIdV2Async,
  getFlowsLookupsAsync,
  getSelectionFlowAsync,
} from './slices';

export const FlowsActions = {
  ...actions,
  getFRlowReaderAsync,
  getFlowsDatatableAsync,
  createFlowAsync,
  getFlowDetailsByIdAsync,
  editFlowAsync,
  setFlowContentEntityTypeNavigationsAsync,
  cloneFlowAsync,
  createFlowV2Async,
  editFlowV2Async,
  getFlowDetailsByIdV2Async,
  getFlowsLookupsAsync,
  getSelectionFlowAsync,
};

export * from './storage';

export * from './types';
